"use client";

import { c as _c } from "react/compiler-runtime";
import { Icon } from "@iconify/react";
import { useCart } from "@/contexts/cartContext";
import { useEffect, useState } from "react";
const DEFAULT_CUTOFF_HOUR = 16; // 2:00 PM
const DEFAULT_CUTOFF_MINUTE = 0;
function getCutoffCountdown(cutoffHour, cutoffMinute) {
  const now = new Date();
  const cutoff = new Date();
  cutoff.setHours(cutoffHour, cutoffMinute, 0, 0);
  let diff = cutoff.getTime() - now.getTime();
  let expired = false;
  if (diff <= 0) {
    // Cutoff already passed today — count towards tomorrow's cutoff instead,
    // but flag it as expired so we can swap the copy.
    const nextCutoff = new Date(cutoff);
    nextCutoff.setDate(nextCutoff.getDate() + 1);
    diff = nextCutoff.getTime() - now.getTime();
    expired = true;
  }
  const totalSeconds = Math.floor(diff / 1000);
  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor(totalSeconds % 3600 / 60),
    seconds: totalSeconds % 60,
    expired
  };
}
function useCutoffCountdown(cutoffHour, cutoffMinute) {
  const $ = _c(4);
  const [countdown, setCountdown] = useState(null);
  let t0;
  let t1;
  if ($[0] !== cutoffHour || $[1] !== cutoffMinute) {
    t0 = () => {
      const tick = () => setCountdown(getCutoffCountdown(cutoffHour, cutoffMinute));
      tick();
      const id = setInterval(tick, 1000);
      return () => clearInterval(id);
    };
    t1 = [cutoffHour, cutoffMinute];
    $[0] = cutoffHour;
    $[1] = cutoffMinute;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return countdown;
}
const pad = n => String(n).padStart(2, "0");
export default function ProductExtras(t0) {
  const $ = _c(18);
  const {
    cutoffHour: t1,
    cutoffMinute: t2
  } = t0;
  const cutoffHour = t1 === undefined ? DEFAULT_CUTOFF_HOUR : t1;
  const cutoffMinute = t2 === undefined ? DEFAULT_CUTOFF_MINUTE : t2;
  const {
    freeDeliveryAmount
  } = useCart();
  const countdown = useCutoffCountdown(cutoffHour, cutoffMinute);
  const isUrgent = !!countdown && !countdown.expired;
  const t3 = Number(freeDeliveryAmount);
  let t4;
  if ($[0] !== t3) {
    t4 = t3.toFixed(0);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = `When u spend £${t4} or more`;
  let t6;
  if ($[2] !== t5) {
    t6 = {
      icon: "mdi:truck-fast",
      title: "Free UK Delivery",
      subtitle: t5
    };
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t10;
  let t7;
  let t8;
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      icon: "mdi:progress-star-four-points",
      title: "Loyalty Rewards",
      subtitle: "Earn Upto 15% Cashback*"
    };
    t8 = {
      icon: "mdi:lock",
      title: "Secure Checkout",
      subtitle: "SSL encrypted & trusted payment methods"
    };
    t9 = {
      icon: "mdi:account-group-outline",
      title: "Trusted by Thousands",
      subtitle: "Over 10,000 happy customers"
    };
    t10 = {
      icon: "mdi:checkbox-marked-circle-auto-outline",
      title: "Price Match Promise",
      subtitle: "We'll match eligible competitor's prices"
    };
    $[4] = t10;
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
  } else {
    t10 = $[4];
    t7 = $[5];
    t8 = $[6];
    t9 = $[7];
  }
  let t11;
  if ($[8] !== t6) {
    t11 = [t6, t7, t8, t9, t10];
    $[8] = t6;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const promos = t11;
  let t12;
  if ($[10] !== promos) {
    t12 = promos.map(_temp);
    $[10] = promos;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== countdown || $[13] !== isUrgent) {
    t13 = countdown && !countdown.expired && <div className="shadow/10 p-2 bg-white rounded flex items-center gap-2"><Icon icon="mdi:calendar-clock" fontSize={32} className="text-primary" title="Want it Tomorrow?" /><div className="leading-tight">{countdown && !countdown.expired ? <div><div>{isUrgent ? <div className="font-bold">Want it tomorrow?</div> : <div className="font-bold">Dispatched tomorrow?</div>}</div><div className="text-xs">For same day dispatch order in next{" "}</div><div className={`font-bold text-lg ${isUrgent ? "text-red-600" : ""}`}><span className="js_hrs">{countdown.hours}</span>h:<span className="js_min">{pad(countdown.minutes)}</span>m:<span className="js_sec">{pad(countdown.seconds)}</span>s</div></div> : <div className="text"><div className="font-bold">Want it tomorrow?</div><div className="text-sm opacity-70 font-medium">Cutoff passed : dispatches tomorrow</div></div>}</div></div>;
    $[12] = countdown;
    $[13] = isUrgent;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t12 || $[16] !== t13) {
    t14 = <div className="pt-3"><div className="grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-4">{t12}{t13}</div></div>;
    $[15] = t12;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  return t14;
}
function _temp(item, index) {
  return <div key={index} className="shadow/20 p-2 bg-white rounded flex items-center gap-2"><Icon icon={item.icon} fontSize={32} className="text-primary" title={item.title} /><div className="leading-tight"><div className="font-bold">{item.title}</div><div className="text-xs font-medium opacity-75">{item.subtitle}</div></div></div>;
}